"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.step = void 0;
const tslib_1 = require("tslib");
const ChecklistControls_1 = require("../../../../TdWebtoolkitControls/controls/Checklist/ChecklistControls");
require("../../../../TdWebtoolkitControls/controls/Wizard/Wizard");
const Utilities_1 = require("../../../../TdWebtoolkitControls/javascript/Utilities");
const lmsModel_1 = require("../../lms/lmsModel");
require("./stepNames");
const stepNames_1 = require("./stepNames");
exports.step = {
    name: stepNames_1.WizardStepNames[stepNames_1.WizardStepNames.questionnaire],
    nextPossibleSteps: [stepNames_1.WizardStepNames[stepNames_1.WizardStepNames.end]],
    canReRun: ($this) => {
        let globalStorage = $this.synWizard("getGlobalStorage");
        if (globalStorage["finished"] === true || globalStorage["questionnaireFinished"] === true)
            return false;
        else
            return true;
    },
    run: ($this) => tslib_1.__awaiter(void 0, void 0, void 0, function* () {
        var _a;
        let pathStorage = $this.synWizard("getPathStorage");
        let lesson = yield lmsModel_1.LMSLesson.fromJSON(pathStorage["lesson"]);
        let lessonId = (_a = lesson.LessonInstance) === null || _a === void 0 ? void 0 : _a.id.value;
        let questionnaire = pathStorage["questionnaire"];
        let $contentDiv = $this.synWizard("getStepContentDiv");
        if (Utilities_1.synUtil.clientDeviceClass !== "phone")
            $contentDiv.css("box-sizing", "border-box").css("padding", "0 20%");
        let markup = require("../../../../TdWebtoolkitControls/templates/questionnaire.tmpl.html");
        let questionnaireGuid = Utilities_1.synUtil.getGUID();
        // Initialize contents
        let configData = {
            synUtil: Utilities_1.synUtil,
            checklistId: "checklist_" + questionnaireGuid,
            prevButtonId: "prevButton_" + questionnaireGuid,
            nextButtonId: "nextButton_" + questionnaireGuid,
            checkButtonId: "checkButton_" + questionnaireGuid,
            okButtonId: "okButton_" + questionnaireGuid,
        };
        // Create HTML from template
        let template = kendo.template(markup);
        $contentDiv.html(template(configData));
        let checklistPane = $("#" + configData.checklistId);
        checklistPane.synChecklist();
        let questionnairePassed = false;
        $("#" + configData.checkButtonId).on("click", function () {
            let newInst = checklistPane.synChecklist("getInstance");
            let requestOptions = {
                instance: JSON.stringify(newInst),
                lessionid: lessonId,
                historyobjectid: lessonId,
            };
            let checklistInstanceUrl = Utilities_1.synUtil.getWSUrl("ChecklistCheckQuestionnaire");
            try {
                Utilities_1.synUtil.getAJAXData({
                    method: "POST",
                    url: checklistInstanceUrl,
                    requestData: requestOptions,
                    done(result) {
                        $("#" + configData.prevButtonId).hide();
                        $("#" + configData.nextButtonId).hide();
                        $("#" + configData.checkButtonId).hide();
                        $("#" + configData.okButtonId).show();
                        $(document).keypress(function (e) {
                            if (e.which === 13)
                                $("#" + configData.okButtonId).trigger("click");
                        });
                        checklistPane.synChecklist("showResult", result);
                        if (result["passed"]) {
                            questionnairePassed = true;
                        }
                        else {
                            questionnairePassed = false;
                        }
                    },
                    cleanUp: () => {
                        Utilities_1.synUtil.endAjaxProgress();
                    }
                });
            }
            catch (error) {
                Utilities_1.synUtil.Notifications.error(error);
            }
        });
        $("#" + configData.nextButtonId).on("click", function () {
            checklistPane.synChecklist("selectNext", configData);
        });
        $("#" + configData.prevButtonId).on("click", function () {
            checklistPane.synChecklist("selectPrevious", configData);
        });
        $("#" + configData.okButtonId).on("click", function () {
            return tslib_1.__awaiter(this, void 0, void 0, function* () {
                if (questionnairePassed) {
                    let globalStorage = $this.synWizard("getGlobalStorage");
                    globalStorage["questionnaireFinished"] = true;
                    yield $this.synWizard("notifyGlobalStorageChanged");
                    $this.synWizard("nextStep");
                }
                else {
                    Utilities_1.synUtil.beginAjaxProgress();
                    let globalStorage = $this.synWizard("getGlobalStorage");
                    globalStorage["briefingFinished"] = false;
                    yield $this.synWizard("notifyGlobalStorageChanged");
                    // Reset SCORM data
                    try {
                        let instance = yield Utilities_1.synUtil.getInstanceAsync(pathStorage["checklistId"]);
                        instance.items["cevisitormanagement.scormdata"].value = undefined;
                        yield Utilities_1.synUtil.getAJAXDataAsync({
                            method: "POST",
                            url: Utilities_1.synUtil.getWSUrl("InstanceSave"),
                            requestData: { instance: JSON.stringify(instance.toJSON()) },
                        });
                    }
                    catch (error) {
                        Utilities_1.synUtil.endAjaxProgress();
                        Utilities_1.synUtil.Notifications.error(error);
                    }
                    yield $this.synWizard("previousStep");
                    Utilities_1.synUtil.endAjaxProgress();
                }
            });
        });
        checklistPane.synChecklist("setInstance", questionnaire, configData, ChecklistControls_1.ChecklistMode.Editor | ChecklistControls_1.ChecklistMode.Questionnaire, false);
    }),
    hideBtnNext: true,
};
